export const getFormatedDate = (currentDate) => {
  return currentDate.split('/').reverse().join('-');
};
